import { Badge } from "@arcadeai/design-system/components/ui/atoms/badge";
import { cn } from "@arcadeai/design-system/lib/utils";
import { ShieldAlert } from "lucide-react";

type OAuthStatusBadgeProps = {
  requiresAuth: boolean;
  className?: string;
};

export const OAuthStatusBadge = ({
  requiresAuth,
  className,
}: OAuthStatusBadgeProps) => {
  if (!requiresAuth) {
    return null;
  }

  return (
    <Badge
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border border-amber-600 bg-amber-600 px-2.5 py-0.5 font-semibold text-white text-xs transition-colors hover:bg-amber-700 active:bg-amber-800",
        className
      )}
    >
      <ShieldAlert className="size-3" />
      Pending Auth
    </Badge>
  );
};
